import { render, staticRenderFns } from "./WxWorkDetailPanel.vue?vue&type=template&id=03b9c132&scoped=true&"
import script from "./WxWorkDetailPanel.vue?vue&type=script&lang=js&"
export * from "./WxWorkDetailPanel.vue?vue&type=script&lang=js&"
import style0 from "./WxWorkDetailPanel.vue?vue&type=style&index=0&id=03b9c132&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03b9c132",
  null
  
)

export default component.exports